import React from 'react';
import { Avatar } from '@mui/material';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

/** Round avatar in the bot's colour. The primary bot gets a sparkle; the group chat gets a people icon. */
export default function BotAvatar({
  bot, group = false, size = 40,
}) {
  const color = bot?.avatar_color || '#1976d2';
  return (
    <Avatar sx={{ width: size, height: size, bgcolor: group ? '#455a64' : color, fontSize: size * 0.42, fontWeight: 600 }}>
      {group && <GroupsOutlinedIcon sx={{ fontSize: size * 0.55 }} />}
      {!group && bot?.is_primary && <AutoAwesomeIcon sx={{ fontSize: size * 0.55 }} />}
      {!group && !bot?.is_primary && (bot?.name || '?').charAt(0).toUpperCase()}
    </Avatar>
  );
}
